import { TherapistAction } from 'src/redux/actions/constant';

const initialState: object = {
  response: null,
  data: [],
  loading: false,
  error: null,
};

export const getAppointmentSlotsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case TherapistAction.GET_APPOINTMENT_SLOTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case TherapistAction.GET_APPOINTMENT_SLOTS_SUCCESS:
      return {
        ...state,
        response: action.payload,
        data: action.payload.data,
        loading: false,
        error: null,
      };
    case TherapistAction.GET_APPOINTMENT_SLOTS_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        error: action.payload,
      };
    case TherapistAction.GET_APPOINTMENT_SLOTS_RESET:
      return initialState;
    default:
      return state;
  }
};

